import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { MatCheckbox } from '@angular/material/checkbox'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { ElderDurationInputComponent, ElderPeriodInputComponent } from '@elderbyte/ngx-starter'
import { Duration, Period } from '@js-joda/core'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { ProcessLeadTimeSpec, ProcessLeadTimeSpecUtils } from '../process-plan'

@Component({
  selector: 'app-process-plan-scheduling',
  templateUrl: './process-plan-scheduling.component.html',
  styleUrls: ['./process-plan-scheduling.component.scss'],
  imports: [
    MatCheckbox,
    MatFormField,
    MatLabel,
    ElderPeriodInputComponent,
    ElderDurationInputComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class ProcessPlanSchedulingComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly processLeadTimeSpec$ = new BehaviorSubject<ProcessLeadTimeSpec>(null)
  public readonly processLTIgnoreWH$ = new BehaviorSubject<boolean>(false)
  public readonly totalPenaltyIndependent$ = new BehaviorSubject<Period>(null)
  public readonly totalPenaltyDependent$ = new BehaviorSubject<Duration>(null)
  public releaseAt$ = new BehaviorSubject<Duration>(null)
  @Output() public releaseAtChanged = new EventEmitter<Duration>()
  public readonly Duration = Duration

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.processLeadTimeSpec$.subscribe((change) => {
      if (change) {
        this.updateTotalPenalty()
        this.updateCheckboxes()
      }
    })

    this.processLTIgnoreWH$.subscribe((checked) => {
      const spec = this.processLeadTimeSpec
      if (spec) {
        if (checked) {
          spec.dependantProcessingLeadTime = Duration.ZERO.toString()
        } else {
          spec.independentProcessingLeadTime = Period.ZERO.toString()
        }
      }
    })
  }

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set processLeadTimeSpec(spec: ProcessLeadTimeSpec) {
    this.processLeadTimeSpec$.next(spec) // share reference with parent component
  }

  public get processLeadTimeSpec(): ProcessLeadTimeSpec {
    return this.processLeadTimeSpec$.getValue()
  }

  @Input()
  public set releaseAt(releaseAt: string) {
    if (releaseAt) {
      this.releaseAt$.next(Duration.parse(releaseAt))
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public updateTotalPenalty() {
    const spec = this.processLeadTimeSpec
    this.totalPenaltyIndependent$.next(
      ProcessLeadTimeSpecUtils.calculateTotalIndependentLeadTime(spec)
    )
    this.totalPenaltyDependent$.next(ProcessLeadTimeSpecUtils.calculateTotalDependentLeadTime(spec))
  }

  public emitReleaseAt($event: Duration) {
    this.releaseAtChanged.emit($event)
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private updateCheckboxes() {
    this.processLTIgnoreWH$.next(
      this.processLeadTimeSpec.independentProcessingLeadTime !== Period.ZERO.toString()
    )
  }
}
